import "core-js/modules/es.array.join";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from "vuex";
import { adddRoleGameProduct } from '@/api/auth/onlineUser';
export default {
  data: function data() {
    return {
      paramsData: {
        role_id: [],
        game_mark: ''
      },
      dialogShow: false,
      gameAllList: [],
      rolesAllList: [],
      rules: {
        role_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        game_mark: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['rolesList'])), {}, {
    getGameData: function getGameData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("d2admin/game/GameList");

              case 2:
                query = _context.sent;
                _this.gameAllList = query || [];

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getRoleList: function getRoleList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.rolesList({
                  page_size: -1
                });

              case 2:
                query = _context2.sent;
                _this2.rolesAllList = query.data;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    open: function open() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.dialogShow = true;

                _this3.getGameData();

                _this3.getRoleList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        role_id: [],
        game_mark: ''
      };
      this.$refs.ruleForm.clearValidate();
      this.dialogShow = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this4.paramsData));
          params.game_mark = params.game_mark.join(",");
          adddRoleGameProduct(params).then(function (res) {
            if (res.status == 200) {
              _this4.$message({
                message: '操作成功',
                type: 'success'
              });

              _this4.clearData();

              _this4.$emit('refreshDataList');
            }
          });
        }
      });
    }
  })
};